import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
type Props = {
  pageLoader?: boolean;
  showProgress?: boolean;
};

const Loader: React.FC<Props> = ({
  pageLoader = false,
  showProgress = true,
}: Props): JSX.Element => {
    return (
    <div data-testid="loader">
      <Backdrop data-testid="backdrop"
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={pageLoader}
        >
         {showProgress && <CircularProgress data-testid="circular-progress" color="inherit" /> }
        </Backdrop>
    </div>
  );
};

export default Loader
